import "core-js/modules/es.array.reverse.js";
var _class;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, isObservableArray, makeObservable } from "mobx";
import FunctionParameter from "./FunctionParameter";
/**
 * A parameter that specifies an arbitrary polygon on the globe, which has been selected from a different layer.
 */
let SelectAPolygonParameter = (_class = class SelectAPolygonParameter extends FunctionParameter {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", "polygon");
    makeObservable(this);
  }
  static formatValueForUrl(value) {
    if (!(Array.isArray(value) || isObservableArray(value))) {
      return undefined;
    }
    const featureList = value.map(function (featureData) {
      return {
        type: "Feature",
        geometry: featureData.geometry
      };
    });
    return JSON.stringify({
      type: "FeatureCollection",
      features: featureList
    });
  }
  static getGeoJsonFeature(value) {
    return value.map(function (featureData) {
      return {
        type: "Feature",
        geometry: featureData.geometry,
        properties: {}
      };
    });
  }
  get geoJsonFeature() {
    return SelectAPolygonParameter.getGeoJsonFeature(this.value);
  }
}, _applyDecoratedDescriptor(_class.prototype, "geoJsonFeature", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoJsonFeature"), _class.prototype), _class);
export { SelectAPolygonParameter as default };